//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from 'vuedraggable';

export default {
    components: {
        draggable: draggable
    },
    props: ['website'],
    data: function data() {
        return {
            types: [],
            selectedFloorplan: {
                square_feet: '',
                bedrooms: '',
                bathrooms: '',
                date_available: '',
                image: '',
                starting_price: '',
                type: ''
            },
            floorplans: [
                //                    {
                //                    id: 0,
                //                    type: 'A1',
                //                    square_feet: 650,
                //                    bedrooms: 1,
                //                    bathrooms: 1,
                //                    date_available: 3,
                //                    starting_price: 850,
                //                    image: 'https://source.unsplash.com/random/200x200'
                //                },

            ],
            image: '',
            type: '',
            addingFloorplan: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('on-type-change', function (typeId) {
            console.log('type changed, prepopulate fields');
            console.log(typeId);
            // use type id here to prepopulate inputs
            if (_this.types.length) {
                for (var i = 0; i < _this.types.length; i++) {
                    if (_this.types[i].id == typeId) {
                        var floorPlanMatch = _this.website.floorplans.find(function (fp) {
                            return fp.unit_type_id === unitTypes[i].id;
                        });
                        var floorPlanVirtualUrl = '';
                        if (floorPlanMatch) {
                            floorPlanVirtualUrl = floorPlanMatch.virtual_tour_url;
                        }
                        _this.selectedFloorplan.square_feet = _this.types[i].square_feet;
                        _this.selectedFloorplan.bedrooms = _this.types[i].bedrooms;
                        _this.selectedFloorplan.bathrooms = _this.types[i].bathrooms;
                        _this.selectedFloorplan.virtual_tour_url = floorPlanVirtualUrl;
                    }
                }
            }
        });

        Event.$on('on-file-change', function (e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            _this.selectedFloorplan.image = files[0];
            _this.createImage(files[0]);
        });
    },

    methods: {
        onFileChange: function onFileChange(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.createImage(files[0]);
        },
        createImage: function createImage(file) {
            var reader = new FileReader();
            var vm = this;
            reader.onload = function (e) {
                vm.image = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        addFloorplan: function addFloorplan(floorplan) {
            Event.$emit('open-slideout');
            this.addingFloorplan = true;
            this.selectedFloorplan = {};
            Event.$emit('show-upload-image');
        },
        editFloorplan: function editFloorplan(floorplan) {
            Event.$emit('open-slideout');

            this.selectedFloorplan = floorplan;

            for (var i = 0; i < this.types.length; i++) {
                if (this.types[i].id === floorplan.unit_type_id) {
                    Event.$emit('update-select', this.types[i]);
                }
            };

            Event.$emit('show-existing-image', floorplan.cdn_url);
        },
        updateOrder: function updateOrder(evt) {
            var _this2 = this;

            axios.post('/prototype/website/' + this.website.id + '/floorplan-order', { floorplans: this.website.floorplans }).then(function () {
                _this2.$snotify.success('Floorplan order was updated');
            });
        },
        saveFloorplan: function saveFloorplan(fp) {
            var _this3 = this;

            // validation
            if (!fp.type) {
                this.$snotify.error('Error adding floorplan: Type is required');
                return false;
            }

            var fd = new FormData();

            fd.append('floorplan_data', 1);
            fd.append('date_available', fp.date_available);
            fd.append('bathrooms', fp.bathrooms);
            fd.append('bedrooms', fp.bedrooms);
            if (fp.image) {
                fd.append('image', fp.image);
            }
            fd.append('starting_price', fp.starting_price);
            fd.append('square_feet', fp.square_feet);
            if (typeof fp.type !== 'undefined') {
                console.log('found fp.type = ' + fp.type);
                fd.append('unit_type_id', fp.type);
            } else {
                console.log('found fp.unit_type_id = ' + fp.unit_type_id);
                fd.append('unit_type_id', fp.unit_type_id);
            }
            fd.append('website_id', this.website.id);
            fd.append('virtual_tour_url', fp.virtual_tour_url);

            var $el = this;
            axios.post('/prototype/website/' + $el.website.id + '/floorplan', fd).then(function (response) {
                if (response.data.error) {
                    _this3.$snotify.error('Error adding floorplan: ' + response.data.error);
                } else {
                    Event.$emit('close-slideout');
                    _this3.$snotify.success('Floorplan has been added');
                    Event.$emit('refresh-property-website', $el.website.property_id);
                    _this3.addingFloorplan = false;
                }
            });
        },
        updateFloorplan: function updateFloorplan(fp) {
            var _this4 = this;

            var fd = new FormData();

            fd.append('date_available', fp.date_available);
            fd.append('bathrooms', fp.bathrooms);
            fd.append('bedrooms', fp.bedrooms);
            fd.append('image', fp.image);
            fd.append('starting_price', fp.starting_price);
            fd.append('square_feet', fp.square_feet);
            if (typeof fp.type !== 'undefined') {
                fd.append('unit_type_id', fp.type);
            } else {
                fd.append('unit_type_id', fp.unit_type_id);
            }
            fd.append('website_id', this.website.id);
            fd.append('virtual_tour_url', fp.virtual_tour_url);

            var $el = this;
            axios.post('/prototype/website/' + $el.website.id + '/floorplan/' + fp.id + '', fd).then(function (response) {
                if (response.data.error) {
                    _this4.$snotify.error('Error updating floorplan: ' + response.data.error);
                } else {
                    _this4.$snotify.success('Floorplan has been updated');
                    Event.$emit('close-slideout');
                    Event.$emit('refresh-property-website', $el.website.property_id);
                }
            });
        },
        deleteFloorplan: function deleteFloorplan(fp) {
            var _this5 = this;

            var $el = this;
            axios.post('/prototype/website/' + $el.website.id + '/floorplan/' + fp.id + '/delete').then(function (response) {
                if (response.data.error) {
                    _this5.$snotify.error('Error deleting floorplan: ' + response.data.error);
                } else {
                    _this5.$snotify.success('Floorplan has been deleted');
                    Event.$emit('close-slideout');
                    Event.$emit('refresh-property-website', $el.website.property_id);
                }
            });
        }
    },
    created: function created() {
        this.$on('on-file-change', this.onFileChange);
    },
    beforeDestroy: function beforeDestroy() {},

    watch: {
        website: { // watch it
            immediate: true,
            handler: function handler(newVal, oldVal) {
                var _this6 = this;

                if (this.website.property.unit_types.length) {
                    var unitTypes = this.website.property.unit_types;
                    this.types = [];

                    var _loop = function _loop(i) {
                        floorPlanMatch = _this6.website.floorplans.find(function (fp) {
                            return fp.unit_type_id === unitTypes[i].id;
                        });
                        floorPlanVirtualUrl = '';

                        if (floorPlanMatch) {
                            floorPlanVirtualUrl = floorPlanMatch.virtual_tour_url;
                        }
                        _this6.types.push({
                            id: unitTypes[i].id,
                            label: unitTypes[i].name,
                            square_feet: unitTypes[i].square_feet,
                            bedrooms: unitTypes[i].bedrooms,
                            bathrooms: unitTypes[i].bathrooms,
                            virtual_tour_url: floorPlanVirtualUrl
                        });
                    };

                    for (var i = 0; i < unitTypes.length; i++) {
                        var floorPlanMatch;
                        var floorPlanVirtualUrl;

                        _loop(i);
                    };
                }
            }
        }
    },
    computed: {
        slideoutTitle: function slideoutTitle() {
            if (Object.keys(this.selectedFloorplan).length == 0) {
                return "Add Floorplan";
            } else {
                return "Edit Floorplan";
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/cms/pages/Floorplans.vue
// module id = 6Exs
// module chunks = 0 1